/*
 * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>
 */

import {Routes } from '@angular/router';
import {NgxPermissionsGuard} from 'ngx-permissions';

import {permissions } from '../../permissions';
import {TransactionsComponent } from './transactions.component';
import {AuthGuardService as AuthGuard} from './../../auth-guard.service';
import {TransactionsDetailsComponent} from './transactions-details/transactions-details.component';
import {TransactionsDynamicsComponent} from './transactions-dynamics/transactions-dynamics.component';
import {TransactionsInOutBoundComponent} from './transactions-in-out-bound/transactions-in-out-bound.component';
import {TransactionsTradingPartnerComponent} from './transactions-trading-partner/transactions-trading-partner.component';
import { TransactionsInventoryDownloadComponent } from './transactions-inventory-download/transactions-inventory-download.component';

export const routes: Routes = [{
    path: 'transactions',
    component: TransactionsComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Transactions',
        permissions: {
            only: [permissions.TRANSACTIONS_READ]
        }
    }
}, {
    path: 'transactions/details',
    component: TransactionsDetailsComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Detail Transaction Report',
        permissions: {
            only: [permissions.TRANSACTIONS_READ]
        }
    }
}, {
    path: 'transactions/dynamics',
    component: TransactionsDynamicsComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Dynamic Transaction Report',
        permissions: {
            only: [permissions.TRANSACTIONS_READ]
        }
    }
}, {
    path: 'transactions/in-out-bound',
    component: TransactionsInOutBoundComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'In/Out Bound Report',
        permissions: {
            only: [permissions.TRANSACTIONS_READ]
        }
    }
}, {
    path: 'transactions/transactions-trading-partner',
    component: TransactionsTradingPartnerComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Transactions Per Trading Partner',
        permissions: {
            only: [permissions.TRANSACTIONS_READ]
        }
    }
}, {
    path: 'transaction-inventory-download',
    component: TransactionsInventoryDownloadComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
        title: 'Download Inventory',
        permissions: {
            only: [permissions.TRANSACTIONS_INVENTORY_DOWNLOAD]
        }
    }
} ];




// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/transactions/transactions.routing.ts